"use client";
import { FC } from "react";

import useFetchBlobUrl from "@stadium/hooks/lib/use-fetch-blob-url";

import Tippy from "@tippyjs/react";
import useCopyLinkToClipboard from "@stadium/ui/src/hooks/use-clipboard";
import Button, { ExternalLinkButton } from "@stadium/shared/src/components/shared/button";
import Multimedia from "@stadium/shared/src/components/shared/multimedia";
import { ThreeProgressiveDots } from "@stadium/ui/src/components/loaders/loaders";

import defaultStyles from "./main.module.scss";

type QRCodeSectionPropsType = {
  url: string;
  id: string;
  qrCode: string;
  header: string;
  headerStyles: string;
  sectionStyles: string;
  leftSectionStyles: string;
  imageBlockStyles: string;
  styles: ModularStyles;
};

const QRCodeSection: FC<QRCodeSectionPropsType> = ({
  url,
  id,
  qrCode,
  header,
  headerStyles = defaultStyles.modalRightContentHeader,
  sectionStyles = defaultStyles.modalRightContentSection,
  imageBlockStyles = defaultStyles.modalRightContentImageBlock,
  leftSectionStyles,
  styles = defaultStyles,
}) => {
  const [copied, copy] = useCopyLinkToClipboard(url);

  const { blobUrl } = useFetchBlobUrl(qrCode);

  const handleCopyLinkClick = () => {
    if (typeof copy === "function") {
      return copy();
    }
    return copy;
  };

  const renderQrCode = () => {
    if (!qrCode) return;
    return (
      <>
        <div className={styles.modalRightContentImageHolder}>
          <Multimedia type="image" src={qrCode} alt={`${id}-qr-code`} />
        </div>
        <div className={styles.modalRightContentImageBlockText}>
          {blobUrl ? (
            <ExternalLinkButton btnStyle="link" href={blobUrl} download={`${id}-QR Code`}>
              <span className={styles.iconDownload} /> DOWNLOAD QR CODE
            </ExternalLinkButton>
          ) : (
            <ThreeProgressiveDots />
          )}
        </div>
      </>
    );
  };

  return (
    <section className={sectionStyles}>
      <div className={leftSectionStyles}>
        {header && <header className={headerStyles}>{header}</header>}
        <div className={styles.shareLinkInputFieldBlock}>
          <span className={styles.shareLinkInputField}>{url}</span>
          <Tippy content={<div>{copied ? "Copied" : "Copy Link"}</div>} hideOnClick={false}>
            <Button
              styleType="link"
              className={styles.shareLinkInputFieldButton}
              onClick={handleCopyLinkClick}
            >
              <span className={styles.iconCopyContent}></span>
            </Button>
          </Tippy>
        </div>
      </div>
      <div className={imageBlockStyles}>{renderQrCode()}</div>
    </section>
  );
};

const WrappedQRCodeSection: FC<QRCodeSectionPropsType> = (props) => {
  if (!props?.url) return;
  return <QRCodeSection {...props} />;
};

export default WrappedQRCodeSection;
